<template>
    <td-dialog
        :lockScroll="false"
        :title="$t(title)"
        :before-close="elementDialogClose"
        :visible.sync="dialogVisible"
        width="690px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="formGroupElementInfo" label-position="right" label-width="95px" ref="formGroupElementInfo" :rules="rules">
            <el-row :gutter="10">
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.EXTEND_ELEMENT')" prop="sElementId">
                        <td-select
                            v-model="formGroupElementInfo.sElementId"
                            :options="optionsElement"
                            keys="sId"
                            text="sNameFlg"
                            value="sElementType"
                            :disabled="elementDisabled"
                            @change="
                                val => {
                                    elementChange(optionsElement);
                                }
                            "
                        ></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item :label="$t('extendCommon.ELEMENT_KEY')" prop="sElementKey">
                        <td-input v-model="formGroupElementInfo.sElementKey" :disabled="keyDisabled"> </td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.BELONG_TO_GROUP')" prop="sGroupId">
                        <td-select v-model="formGroupElementInfo.sGroupId" :disabled="true" :options="optionsGroup" keys="sId" text="sName" :clearable="false" @change="groupChange"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item :label="$t('extendCommon.SHOW_NAME')" prop="sViewName">
                        <td-input v-model="formGroupElementInfo.sViewName"> </td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.SHOW_ORDER')" prop="iOrder">
                        <td-input-number v-model="formGroupElementInfo.iOrder" :disabled="true" :min="1" :max="500"> </td-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item :label="$t('extendCommon.SHOW_FORMAT')" prop="iColNum">
                        <td-select v-model="formGroupElementInfo.iColNum" :options="optionsFormat" :clearable="false"></td-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.ELEMENT_HIDDEN')">
                        <td-radio v-model="formGroupElementInfo.iHidden" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item :label="$t('extendCommon.ELEMENT_NOT_NULL')">
                        <td-radio v-model="formGroupElementInfo.iNeeded" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.ELEMENT_SHOW_LABEL')">
                        <td-radio v-model="formGroupElementInfo.iShowLabel" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item :label="$t('extendCommon.ELEMENT_OPTION_NAME')">
                        <td-input v-model="formGroupElementInfo.sOptionName"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.SELF_VALIDATE')">
                        <td-input v-model="formGroupElementInfo.customRulesMethod"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 属性 -->
            <el-row :gutter="10">
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.ELEMENT_PROP')">
                        <td-select v-model="formGroupElementInfo.sElementProp" :options="optionsElementProps" keys="sName" text="sName" @change="elementPorpChange(optionsElementProps)"></td-select>
                    </el-form-item>
                </el-col>

                <el-col :span="10">
                    <el-form-item :label="$t('extendCommon.ELEMENT_PROP_VAL')">
                        <td-input v-model="formGroupElementInfo.sElementPropVal"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3" class="paddingTop10">
                    <td-button type="text" @click="addElementPropToJson">{{ $t('extendCommon.ADD') }}</td-button>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="22">
                    <el-form-item :label="$t('extendCommon.ELEMENT_PROPS_JSON')" prop="sElementPropsJson">
                        <td-input v-model="formGroupElementInfo.sElementPropsJson" type="textarea" width="100%" :placeholder="propsJsonDemo"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 事件 -->
            <el-row :gutter="10">
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.ELEMENT_EVENT')">
                        <td-select
                            v-model="formGroupElementInfo.sElementEvent"
                            :options="optionsElementEvents"
                            keys="sName"
                            text="sName"
                            @change="elementEventsChange(optionsElementEvents)"
                        ></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item :label="$t('extendCommon.ELEMENT_METHOD')">
                        <td-input v-model="formGroupElementInfo.sElementEventVal"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3" class="paddingTop10">
                    <td-button type="text" @click="addElementEventToJson">{{ $t('extendCommon.ADD') }}</td-button>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="22">
                    <el-form-item :label="$t('extendCommon.ELEMENT_EVENTS_JSON')" prop="sElementEventsJson">
                        <td-input v-model="formGroupElementInfo.sElementEventsJson" type="textarea" width="100%" :placeholder="eventsJsonDemo"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formGroupElementInfo')" :loading="submitLoading">{{ $t('extendCommon.SAVE') }}</td-button>
            <td-button @click="elementDialogClose">{{ $t('extendCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import groupElementApi from './../assets/api.js';
export default {
    props: ['title', 'dialogVisible', 'editItem', 'isAddData', 'maxExtendOrder', 'groupId'],
    created() {
        this.initElementList();
        this.initGroupList();
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.elementDisabled = true;
            this.keyDisabled = true;
            this.initEditData();
        } else {
            // 默认新增排序字段为当前数据库中最大的排序字段值
            this.formGroupElementInfo.iOrder = this.maxExtendOrder;
            this.formGroupElementInfo.iColNum = this.optionsFormat[0].value;
            this.formGroupElementInfo.sGroupId = this.groupId;
        }
    },
    // 定义变量
    data() {
        let validateElementKey = (rule, value, callback) => {
            let sId = '';
            if (!this.isAddData) {
                sId = this.formGroupElementInfo.sId;
            }
            let param = {
                sId: sId,
                sGroupId: this.formGroupElementInfo.sGroupId,
                sElementKey: value
            };
            groupElementApi.checkElementKey(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/checkElementKey', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('extendError.ERROR_ELEMENT_KEY_EXIST'));
                } else {
                    callback();
                }
            });
        };
        //判断是否是JSON结构字符串
        let isJsonString = (rule, value, callback) => {
            try {
                if (!this.$util.isEmpty(value)) {
                    let obj = JSON.parse(value);
                    if (typeof obj == 'object' && obj) {
                        callback();
                    } else {
                        callback(this.$t('extendError.ERROR_JSON_FORMAT'));
                    }
                }
                callback();
            } catch (err) {
                callback(this.$t('extendError.ERROR_JSON_FORMAT'));
            }
        };

        return {
            propsJsonDemo: '{"控件属性1": "属性值1","控件属性2": "属性值2"}',
            eventsJsonDemo: '[{"event":"控件事件1","method":"方法名1"},{"event":"控件事件2","method":"方法名2"}]',
            elementDisabled: false, //扩展元素下拉框可用性
            keyDisabled: false, //元素关键字可用性
            // 扩展元素数组
            optionsElement: [],
            // 扩展元素属性数组
            optionsElementProps: [],
            // 扩展元素属性数组
            optionsElementEvents: [],
            //所属扩展组
            optionsGroup: [],
            // 表单信息
            formGroupElementInfo: {
                sId: '',
                sGroupId: '',
                sElementId: '',
                sViewName: '',
                iOrder: 1,
                iColNum: '',
                customRulesMethod: '',
                iHidden: 1,
                iNeeded: 1,
                iShowLabel: 0,
                sOptionName: 'options',
                sElementProp: '',
                sElementVal: '',
                sElementKey: '',
                sElementEvent: '',
                sElementPropVal: '',
                sElementEventVal: '',
                sElementPropsJson: '',
                sElementEventsJson: ''
            },
            submitLoading: false, // 保存按钮是否为加载状态
            optionsFormat: [
                {
                    value: 24,
                    label: this.$t('extendCommon.A_ROW')
                },
                {
                    value: 12,
                    label: this.$t('extendCommon.B_ROW')
                },
                {
                    value: 8,
                    label: this.$t('extendCommon.C_ROW')
                },
                {
                    value: 6,
                    label: this.$t('extendCommon.D_ROW')
                }
            ],
            requiredType: [
                //请求类型
                {
                    value: 0,
                    label: this.$t('extendCommon.IS_TRUE')
                },
                {
                    value: 1,
                    label: this.$t('extendCommon.DENY')
                }
            ],
            // 对表单进行数据验证
            rules: {
                sElementId: [{ required: true, message: this.$t('extendError.ERROR_PLEASE_SELECT_ELEMENT'), trigger: 'change' }],
                sElementKey: [
                    { required: true, message: this.$t('extendError.ERROR_PLEASE_INPUT_ELEMENT_KEY'), trigger: 'blur' },
                    { pattern: window.tdExtend.regex.ENGLISH_AND_NUM_UNDERLINE, message: this.$t('extendRegex.ONLY_ENGLISH_NUM_UNDERLINE'), trigger: 'blur' },
                    { validator: validateElementKey, trigger: 'blur' }
                ],
                sViewName: [{ required: true, message: this.$t('extendError.ERROR_PLEASE_INPUT_GROUP_NAME'), trigger: 'change' }],
                sGroupId: [{ required: true, message: this.$t('extendError.ERROR_PLEASE_SELECT_GROUP'), trigger: 'change' }],
                sElementPropsJson: [{ validator: isJsonString, trigger: 'blur' }],
                sElementEventsJson: [{ validator: isJsonString, trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formGroupElementInfo.sId = this.editItem.sId;
            this.formGroupElementInfo.sGroupId = this.editItem.sGroupId;
            this.formGroupElementInfo.sElementId = this.editItem.sElementId;
            this.formGroupElementInfo.sViewName = this.editItem.sViewName;
            this.formGroupElementInfo.iOrder = this.editItem.iOrder;
            this.formGroupElementInfo.iColNum = this.editItem.iColNum;
            this.formGroupElementInfo.iHidden = this.editItem.iHidden;
            this.formGroupElementInfo.iNeeded = this.editItem.iNeeded;
            this.formGroupElementInfo.iShowLabel = this.editItem.iShowLabel;
            this.formGroupElementInfo.sOptionName = this.editItem.sOptionName;
            this.formGroupElementInfo.sElementKey = this.editItem.sElementKey;
            this.formGroupElementInfo.customRulesMethod = this.editItem.sCustomRulesMethod;
            this.formGroupElementInfo.sElementPropsJson = this.editItem.sElementPropsJson;
            this.groupChange(this.formGroupElementInfo.sGroupId);
            this.formGroupElementInfo.sElementEventsJson = this.editItem.sElementEventsJson;
        },
        // 初始化扩展元素下拉框数据
        initElementList() {
            let params = {
                isPage: false
            };
            groupElementApi.listExtendElementInfo(JSON.stringify(params), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('extendManage/listExtendElementInfo', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/listExtendElementInfo', response.data.statusMessage);
                    return;
                }
                if (!this.$util.isEmpty(response.data.content)) {
                    for (let i = 0; i < response.data.content.length; i++) {
                        response.data.content[i].sNameFlg = response.data.content[i].sName + '：' + response.data.content[i].sElementFlg;
                    }
                }
                this.optionsElement = response.data.content;
                this.elementChange(this.optionsElement);
            });
        },
        // 初始化所属扩展组下拉框数据
        initGroupList() {
            let params = {
                parentId: 'extendGroupRootId',
                isPage: false
            };
            groupElementApi.listExtendGroupInfos(JSON.stringify(params), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('extendManage/findExtendGroupTree', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/findExtendGroupTree', response.data.statusMessage);
                    return;
                }
                this.optionsGroup = response.data.content;
            });
        },
        initElementPropsByType(elementType) {
            let params = {
                sElementType: elementType
            };
            //获取当前控件属性
            groupElementApi.queryElementPropsByType(JSON.stringify(params), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('extendManage/queryElementPropsByType', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/queryElementPropsByType', response.data.statusMessage);
                    return;
                }
                this.optionsElementProps = response.data.content;
            });
            //获取当前控件事件
            groupElementApi.queryElementEventsByType(JSON.stringify(params), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('extendManage/queryElementEventsByType', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/queryElementEventsByType', response.data.statusMessage);
                    return;
                }
                this.optionsElementEvents = response.data.content;
            });
        },
        elementChange(data) {
            let elementType = '';
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.sId === this.formGroupElementInfo.sElementId) {
                    elementType = element.sElementType;
                    //默认扩展元素显示名称
                    if (this.isAddData) {
                        this.formGroupElementInfo.sViewName = element.sViewName;
                    }
                }
            }
            if (elementType === '') {
                return;
            }
            this.initElementPropsByType(elementType);
        },
        groupChange(data) {
            if (this.$util.isEmpty(data)) {
                this.formGroupElementInfo.sElementKey = '';
            }
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    var content = {
                        sGroupId: this.formGroupElementInfo.sGroupId,
                        sElementId: this.formGroupElementInfo.sElementId,
                        sElementKey: this.formGroupElementInfo.sElementKey,
                        sViewName: this.formGroupElementInfo.sViewName,
                        iOrder: this.formGroupElementInfo.iOrder,
                        iColNum: this.formGroupElementInfo.iColNum,
                        iHidden: this.formGroupElementInfo.iHidden,
                        iNeeded: this.formGroupElementInfo.iNeeded,
                        iShowLabel: this.formGroupElementInfo.iShowLabel,
                        sOptionName: this.formGroupElementInfo.sOptionName,
                        sCustomRulesMethod: this.formGroupElementInfo.customRulesMethod,
                        sElementPropsJson: this.formGroupElementInfo.sElementPropsJson,
                        sElementEventsJson: this.formGroupElementInfo.sElementEventsJson
                    };
                    if (this.isAddData) {
                        groupElementApi.insertGroupElement(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('extendManage/insertGroupElement', response.data.statusMessage);
                                this.submitLoading = false;
                                return;
                            }
                            this.submitLoading = false;
                            this.$message({ showClose: true, message: this.$t('extendCommon.ADD_SUCCESS'), type: 'success' });
                            this.elementDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('callbackQuery');
                        });
                    } else {
                        content.sId = this.editItem.sId;
                        groupElementApi.updateGroupElement(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('extendManage/updateGroupElement', response.data.statusMessage);
                                this.submitLoading = false;
                                return;
                            }
                            this.submitLoading = false;
                            this.$message({ showClose: true, message: this.$t('extendCommon.MODIFY_SUCCESS'), type: 'success' });
                            this.elementDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('callbackQuery');
                        });
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        elementDialogClose() {
            this.$emit('elementDialogClose');
            this.$refs['formGroupElementInfo'].resetFields(); // 重置表单数据
        },
        addElementPropToJson() {
            let regText = this.formGroupElementInfo.sElementPropVal;
            if ('' == regText) {
                return;
            }
            let oldVal = {};
            if (this.formGroupElementInfo.sElementPropsJson !== '') {
                try {
                    oldVal = JSON.parse(this.formGroupElementInfo.sElementPropsJson);
                } catch (e) {
                    this.$message({ showClose: true, message: this.$t('extendError.ERROR_JSON_FORMAT'), type: 'error' });
                    // return;
                }
            }
            let newVal;
            try {
                newVal = eval('(' + this.formGroupElementInfo.sElementPropVal + ')');
            } catch (e) {
                newVal = this.formGroupElementInfo.sElementPropVal;
            }
            this.createJson(this.formGroupElementInfo.sElementProp, newVal, oldVal);
            this.formGroupElementInfo.sElementPropsJson = JSON.stringify(oldVal);
        },
        addElementEventToJson() {
            let regText = this.formGroupElementInfo.sElementEventVal;
            if ('' == regText) {
                return;
            }

            let allEvents = [];
            if (this.formGroupElementInfo.sElementEventsJson !== '') {
                try {
                    allEvents = JSON.parse(this.formGroupElementInfo.sElementEventsJson);
                } catch (e) {
                    this.$message({ showClose: true, message: this.$t('extendError.ERROR_JSON_FORMAT'), type: 'error' });
                }
            }
            let event = {};
            this.createJson('event', this.formGroupElementInfo.sElementEvent, event);
            this.createJson('method', this.formGroupElementInfo.sElementEventVal, event);
            let updateFlg = false;
            for (let index = 0; index < allEvents.length; index++) {
                const element = allEvents[index];
                if (element.event === this.formGroupElementInfo.sElementEvent) {
                    element.method = this.formGroupElementInfo.sElementEventVal;
                    updateFlg = true;
                    break;
                }
            }
            if (!updateFlg) {
                allEvents.push(event);
            }

            this.formGroupElementInfo.sElementEventsJson = JSON.stringify(allEvents);
        },
        createJson(prop, val, props) {
            // 如果 val 被忽略
            if (typeof val === 'undefined' || val === '') {
                // 删除属性
                delete props[prop];
            } else {
                // 添加 或 修改
                props[prop] = val;
            }
        },
        strMapToObj(strMap) {
            let obj = Object.create(null);
            for (let [k, v] of strMap) {
                obj[k] = v;
            }
            return obj;
        },
        elementPorpChange(option) {
            this.formGroupElementInfo.sElementPropVal = '';
            console.log(option);
        },
        elementEventsChange(option) {
            this.formGroupElementInfo.sElementEventVal = '';
            console.log(option);
        }
    }
};
</script>
<style></style>
